export var SOURCE_POSITION_ONEPASS_HERO_EVENT = 1;
export var NULL_FROM_PRODUCT = {
  from_product_ids: null,
  from_product_displayed_price: null,
  from_product_offer_id: null
};